<template>
  <div class="pa-7">
    <!--ライオンズマンション空室状況-->
    <v-card>
      <!--物件名-->
      <v-card-title>
        <i class="far fa-building mr-3" style="color: #3F51B5" />
        {{ title }}
        <v-spacer />
        <span
        class="mr-1"
        id="update">
          {{ update }}
        </span>
      </v-card-title>
      <v-divider />
      <!-- データテーブルの内容 -->
      <template>
      <v-data-table
      :headers="header"
      :items="properties">
      </v-data-table>
      </template>
    </v-card>
  </div>
</template>

<style>
#update {
  font-size: 16px;
}
</style>

<script>
export default {
  data () {
    return {
      title: 'マンション空室状況',
      update: '2024/03/01 更新',
      header: [
        {
          text: '物件名',
          value: 'name',
          sortable: false,
          align: 'center'
        },
        {
          text: '部屋',
          value: 'roomFloor',
          sortable: false,
          align: 'center'
        },
        {
          text: '家賃（万円）',
          value: 'rent',
          sortable: false,
          align: 'center'
        },
        {
          text: '敷金（千円）',
          value: 'deposit',
          sortable: false,
          align: 'center'
        },
        {
          text: '礼金（千円）',
          value: 'reward',
          sortable: false,
          align: 'center'
        },
        {
          text: '間取り/専有面積',
          value: 'floorPlan',
          sortable: false,
          align: 'center'
        },
        {
          text: '現況',
          value: 'status',
          sortable: false,
          align: 'center'
        }
      ],
      properties: [
        {
          // 物件名
          name: '第３井村ハイツ',
          // 階
          roomFloor: '101',
          // 賃料
          rent: '2.5',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: '内装済'
        },
        {
          // 物件名
          name: '第３井村ハイツ',
          // 階
          roomFloor: '205',
          // 賃料
          rent: '2.5',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: '内装済'
        },
        {
          // 物件名
          name: '第３井村ハイツ',
          // 階
          roomFloor: '403',
          // 賃料
          rent: '2.5',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: '内装済'
        },
        {
          // 物件名
          name: '第３井村ハイツ',
          // 階
          roomFloor: '405',
          // 賃料
          rent: '2.5',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: '内装済'
        },
        {
          // 物件名
          name: '第３井村ハイツ',
          // 階
          roomFloor: '406',
          // 賃料
          rent: '2.5',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: '内装済'
        },
        {
          // 物件名
          name: '第１井村ハイツ',
          // 階
          roomFloor: '105',
          // 賃料
          rent: '2.8',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: '内装済'
        },
        {
          // 物件名
          name: '第１井村ハイツ',
          // 階
          roomFloor: '202',
          // 賃料
          rent: '2.8',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: '内装済'
        },
        {
          // 物件名
          name: '第１井村ハイツ',
          // 階
          roomFloor: '203',
          // 賃料
          rent: '2.8',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: ''
        },
        {
          // 物件名
          name: 'コーポファストステージ',
          // 階
          roomFloor: '102',
          // 賃料
          rent: '3.2',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: '3/20空'
        },
        {
          // 物件名
          name: 'コーポファストステージ',
          // 階
          roomFloor: '203',
          // 賃料
          rent: '',
          // 敷金
          deposit: '1ヶ月',
          // 礼金
          reward: '',
          // 間取り
          floorPlan: '',
          // ㎡
          square: '',
          // 現況
          status: '3/末空'
        },
        {
          // 物件名
          name: 'ダイアパレス新内町',
          // 階
          roomFloor: '803',
          // 賃料
          rent: '5.5',
          // 敷金
          deposit: '5.5',
          // 礼金
          reward: '5.5',
          // 間取り
          floorPlan: '2LDK',
          // ㎡
          square: '',
          // 現況
          status: '内装済'
        }
      ]
    }
  }
}
</script>
